module.exports = __webpack_public_path__ + "img/example-dogs.8a20be4b.jpg";